import { gql } from "@apollo/client";

export const GetTicketByNode = gql`
  query GetTicketByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsTickets {
        id
        ticketNo
        ticketDate
        reason
        type
        openRemarks
        lastRemarks
        poleNum
        tableLevel
        priority
        item {
          icon
        }
        itemDetails {
          id
        }
        siteID
        junction {
          id
          name
          code
          alias
          jType
          arms
          icon
          vendorDetails {
            desc
          }
        }
        company {
          id
          name
        }
        subsidiaryDetails {
          id
          name
        }
        site {
          id
          name
        }
        loggedUser {
          id
          name
          kgid
          empType
          mobile
        }
      }
    }
  }
`;
